import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from 'axios';
import { variables } from '../Variables';
import { useEffect, useState } from "react";
import { MultiSelect } from "react-multi-select-component";

import settingsBlack from '../assets/images/setting-icon-properties-page.svg';
import notification from '../assets/images/notification.svg';
import searchIcon from '../assets/images/search-icon.svg';
import filterIcon from '../assets/images/filter-red-icon.svg';
import loadSmallBlueIcon from '../assets/images/loading-small-blue.svg';
import houseIdentificationOrangeBatch from '../assets/images/house-identification-orange-batch.svg';
import locationBlue from '../assets/images/location-blue.svg';
import bedBlue from '../assets/images/bed-blue.png';
import areaBlue from '../assets/images/area-blue.svg';
import showerBlue from '../assets/images/shower-blue.svg';
import parkingBlue from '../assets/images/parking-blue.png';
import garageBlue from '../assets/images/garage-blue.svg';
import batchPropertiesVerification from '../assets/images/property-batch.svg';
import pebIcon from '../assets/images/peb-icon.png';
import dotWhite from '../assets/images/dot-white.svg';
import settingBlue from '../assets/images/settings-blue.svg';
import arrowDownWhite from '../assets/images/arrow-down-white.svg';
import arrowUpBlack from '../assets/images/arrow-up-black.svg';
import menuDotsHorizontal from '../assets/images/menu-dots-horizontal.svg';
import clockGreen from '../assets/images/clock-green.svg';
import confirmEventsIcon from '../assets/images/properties-freeslot-icon.svg';
import freeSlotEventsIcon from '../assets/images/free-slot-events-icon.svg';
import toBeConfirmedEventsIcon from '../assets/images/to-be-confirm-events-card-icon.svg';
import redDotIcon from '../assets/images/red-dot.svg';
import orangeDotIcon from '../assets/images/orange-dot.svg';
import placeholderHouse from '../assets/images/prop-placeholder-sm.jpg';
import menGreenIcon from '../assets/images/men-green-icon.svg';

//egergy flag
import energyFlagA from '../assets/engeryFlag/A.png';
import energyFlagAp from '../assets/engeryFlag/Ap.png';
import energyFlagApp from '../assets/engeryFlag/App.png';
import energyFlagB from '../assets/engeryFlag/B.png';
import energyFlagC from '../assets/engeryFlag/C.png';
import energyFlagD from '../assets/engeryFlag/D.png';
import energyFlagE from '../assets/engeryFlag/E.png';
import energyFlagF from '../assets/engeryFlag/F.png';
import energyFlagG from '../assets/engeryFlag/G.png';

import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { PropertyEventsCard } from "../ui/PropertyEventsCard";
import { ConfirmationModal } from "../publicPages/ConfirmationModal";
import { deleteEstateFreeSlotEventsFromDB } from "../services/DeleteEstateAllFreeSlotEventsFromDBService";
import { addNewActionsLog, getEstateStatusFromInDB } from "../utils/commonService";
import { getDisplayStatusService, getEstatePurposeStatusListService, updateParentActionLog } from "../services/commonService";
import { capitalizeFirst, getStartingNumber, toAllCaps } from "../utils/validate";
import { EstateActionListMenu } from "../ui/EstateActionListMenu";
import { ContactWaitingListModel } from "./ContactWaitingListModel";
import { getWhiseOfficeListService } from "../services/whiseApiService";
import { useRef } from "react";
import { getSingleEstateDetail } from "../services/EstateLogicService";
import { setsetting } from "../features/SettingSlice";
//import { useDispatch } from "react-redux";
//import { setsetting } from "../features/SettingSlice";

export const Properties = ({ showMessage }) => {

    const user = useSelector(state => state.user.user);
    const reduxClientToken = useSelector(state => state.whiseClientToken.whiseClientToken);
    const reduxSelectedLanguage = useSelector(state => state.selectedLanguageTranslations.selectedLanguage);
    const reduxLanguageTranslations = useSelector(state => state.selectedLanguageTranslations.selectedLanguageTranslations);
    const reduxClientSetting = useSelector(state => state.setting.setting);
    const filterRef = useRef(null);
    const actionMenuRef = useRef(null);
    const dispatch = useDispatch();

    const clientId = user.user.clientId;
    const officeId = user.user.officeId;

    // All estates with their events from the new API
    const [allEstateWithEvents, setAllEstateWithEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchInput, setSearchInput] = useState("");
    const [enableFilterList, setEnableFilterList] = useState(false);
    const [searchEstateId, setSearchEstateId] = useState("");

    const [currentPage, setCurrentPage] = useState(1);
    const [hasMore, setHasMore] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const pageSize = 20; //10
    const [selectedSmartCalStatus, setSelectedSmartCalStatus]     = useState([]);
    const [selectedAgencies, setSelectedAgencies]                 = useState([]);
    const [selectedTransactionTypes, setSelectedTransactionTypes] = useState([]);
    const [openActionMenu, setOpenActionMenu] = useState(null); // stores the estate index

    // Track expanded/collapsed per estate by index — all start collapsed
    const [expandedEstates, setExpandedEstates] = useState({});

    const [showCalendarLoader, setShowCalendarLoader] = useState(false);
    const [confirmWindowMessage, setConfirmWindowMessage] = useState("Do you want to delete past free slots?");
    const [confirmationFreeSlotDeletModel, setConfirmationFreeSlotDeletModel] = useState(false);
    const [currentEstateId, setCurrentEstateId] = useState(null);

    const [selectOffice, setSelectOffice] = useState([]);
    const [officeList, setOfficeList] = useState([]);
    const [estatePurposeList, setEstatePurposeList] = useState([]);
    const [estateDisplayStatus, setEstateDisplayStatus] = useState([]);

    const [historyActionLogsCount, setHistoryActionLogsCount] = useState(null);
    const [estateJobStatusBtn, setEstateJobStatusBtn] = useState(null);

    //useEffect(() => {
    //    if (officeId && user?.tokenValue) {
    //        const jsonconfig = {
    //            headers: {
    //                'Authorization': `Bearer ${user.tokenValue}`,
    //                'Content-Type': 'application/json'
    //            }
    //        };
    //        const url = variables.API_URL + `Settings/GetSetting?officeId=` + officeId;
    //        axios.get(url, jsonconfig)
    //            .then(response => {
    //                if (response.data != null) {
    //                    dispatch(setsetting(response.data));
    //                }
    //            })
    //            .catch(error => {
    //                console.log(error);
    //            });
    //    }
    //}, [officeId]);

    //get client setting

    //const fetchLatestClientSetting = () => {
    //    if (officeId && user?.tokenValue) {
    //        const jsonconfig = {
    //            headers: {
    //                'Authorization': `Bearer ${user.tokenValue}`,
    //                'Content-Type': 'application/json'
    //            }
    //        };
    //        const url = variables.API_URL + `Settings/GetSetting?officeId=` + officeId;
    //        axios.get(url, jsonconfig)
    //            .then(response => {
    //                if (response.data != null) {
    //                    dispatch(setsetting(response.data));
    //                }
    //            })
    //            .catch(error => {
    //                console.log(error);
    //            });
    //    }
    //}


    // get all estate and events record
    const getAllEstateWithEvents = async (page = 1, append = false) => {
        try {
            append ? setLoadingMore(true) : setLoading(true);
            const agencyParam  = selectedAgencies.length        > 0 ? `&officeIds=${selectedAgencies.map(o => o.value).join(",")}` : "";
            const purposeParam = selectedTransactionTypes.length > 0 ? `&sortByPurpose=${selectedTransactionTypes.map(p => p.value).join(",")}` : "";
            const statusParam = selectedSmartCalStatus.length > 0 ? `&includeStatus=${selectedSmartCalStatus.map(s => s.value).join(",")}` : "";
            const url = variables.API_URL + `Estate/GetEstatesWithEvents?clientId=${clientId}&pageNumber=${page}&pageSize=${pageSize}${purposeParam}${statusParam}&search=${searchInput || searchEstateId}${agencyParam}`;
            //console.log(url);
            const config = {
                headers: {
                    'Authorization': `Bearer ${user.tokenValue}`,
                    'Content-Type': 'application/json'
                }
            };
            const response = await axios.get(url, config);
            if (response.data && response.data.data) {
                const newData = response.data.data;
                setAllEstateWithEvents(prev => append ? [...prev, ...newData] : newData);
                const totalRecords = response.data.totalRecords ?? 0;
                setHasMore(page * pageSize < totalRecords);
                setCurrentPage(page);

                const getPurposeStatus = await getEstatePurposeStatusListService();
                setEstatePurposeList(getPurposeStatus);

                const getDisplayStatus = await getDisplayStatusService();
                setEstateDisplayStatus(getDisplayStatus);
            }
        } catch (err) {
            console.error("GetEstatesWithEvents error:", err);
        } finally {
            append ? setLoadingMore(false) : setLoading(false);
        }
    };

    // expaned and collapse events cards
    const toggleExpand = (index, estateId) => {
        setExpandedEstates(prev => ({ ...prev, [index]: !prev[index] }));
        getHistoryActionLogsByEstateId(estateId);
        getEstatePurposeConfigJobStatusBtn(estateId);
        getOfficeSettings();
    };

    const formatDateTime = (startISO, endISO) => {
        if (!startISO) return { dateStr: "—", timeStr: "—" };

        const days = reduxLanguageTranslations ? [
            reduxLanguageTranslations["Sun"] || "Sun",
            reduxLanguageTranslations["Mon"] || "Mon",
            reduxLanguageTranslations["Tue"] || "Tue",
            reduxLanguageTranslations["Wed"] || "Wed",
            reduxLanguageTranslations["Thur"] || "Thur",
            reduxLanguageTranslations["Fri"] || "Fri",
            reduxLanguageTranslations["Sat"] || "Sat",
        ] : ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"];

        const months = reduxLanguageTranslations ? [
            reduxLanguageTranslations["Jan"] || "Jan",
            reduxLanguageTranslations["Feb"] || "Feb",
            reduxLanguageTranslations["Mar"] || "Mar",
            reduxLanguageTranslations["Apr"] || "Apr",
            reduxLanguageTranslations["May"] || "May",
            reduxLanguageTranslations["Jun"] || "Jun",
            reduxLanguageTranslations["Jul"] || "Jul",
            reduxLanguageTranslations["Aug"] || "Aug",
            reduxLanguageTranslations["Sep"] || "Sep",
            reduxLanguageTranslations["Oct"] || "Oct",
            reduxLanguageTranslations["Nov"] || "Nov",
            reduxLanguageTranslations["Dec"] || "Dec",
        ] : ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        const s = new Date(startISO);
        const e = endISO ? new Date(endISO) : null;
        const dateStr = `${days[s.getDay()]} ${s.getDate()} ${months[s.getMonth()]} ${s.getFullYear()}`;
        const pad = n => String(n).padStart(2, "0");
        const startTime = `${pad(s.getHours())}:${pad(s.getMinutes())}`;
        const endTime = e ? `${pad(e.getHours())}:${pad(e.getMinutes())}` : "";
        return { dateStr, timeStr: endTime ? `${startTime} - ${endTime}` : startTime };
    };

    // Get propertyStatus badge label & color from estate.propertyStatus
    const getStatusBadge = (propertyStatus) => {
        switch (propertyStatus) {
            case "Active": return { label: "Active", bg: "#198754" };
            case "Start": return { label: "Start", bg: "#FB943A" };
            case "Pending": return { label: "Pending", bg: "#FB943A" };
            default: return { label: propertyStatus || "—", bg: "#6c757d" };
        }
    };

    // get display status
    const getDisplayStatusBadge = (smartCalendarStatus) => {
        if (smartCalendarStatus === true) {
            return { label: "Online", bg: "#27A376" };
        } else if (smartCalendarStatus === false) {
            return { label: "Offline", bg: "#27A376" };
        } else {
            return { label: "—", bg: "#27A376" };
        }
    };

    const buildEventsArray = (item) => {
        const result = [];

        // ── Confirmed events ──
        if (item.confirmedCount > 0 && item.confirmed.length > 0) {
            const confirmedEvents = item.confirmed.map((c, i) => {
                const { dateStr, timeStr } = formatDateTime(c.event?.startDateTime, c.event?.endDateTime);
                return {
                    id: c.event?.id || i,
                    eventCount: item.confirmedCount,
                    eventTitle: reduxLanguageTranslations ? reduxLanguageTranslations["confirmedVisits"] : "Visites confirmés",
                    eventSubTitle: reduxLanguageTranslations ? reduxLanguageTranslations["nextVisit"] : "PROCHAINE VISITE",
                    agentName: c.agent ? `${c.agent.firstName} ${c.agent.name}` : "—",
                    eventDateTime: dateStr,
                    eventDurationTime: timeStr,
                    contactId: c.contact?.id,
                    eventId: c.event?.whiseEventId,
                    clientId: item.estate.clientId,
                    officeId: item.estate.officeId,
                    contactFirstName: c.contact?.firstName,
                    contactName: c.contact?.name,
                    contactLanguage: c.contact?.languageId || "en-GB",
                    estateId: item.estate.id,
                    agentId: c.agent?.externalId,
                    internalEventId: c.event?.id,
                };
            });
            result.push({ confirmedEvents });
        } else {
            result.push({
                confirmedEvents: [{
                    id: 0,
                    eventCount: item.confirmedCount,
                    eventTitle: reduxLanguageTranslations ? reduxLanguageTranslations["confirmedVisits"] : "Visites confirmés",
                    eventSubTitle: reduxLanguageTranslations ? reduxLanguageTranslations["nextVisit"] : "PROCHAINE VISITE",
                    agentName: "—",
                    eventDateTime: "—",
                    eventDurationTime: "—",
                }]
            });
        }

        // ── Free slot events ──
        if (item.freeSlotsCount > 0 && item.freeSlots.length > 0) {
            const freeSlotEvents = item.freeSlots.map((f, i) => {
                const { dateStr, timeStr } = formatDateTime(f.event?.startDateTime, f.event?.endDateTime);
                return {
                    id: f.event?.id || i,
                    eventCount: item.freeSlotsCount,
                    eventTitle: reduxLanguageTranslations ? reduxLanguageTranslations["freeTimeSlots"] : "Créneaux libres",
                    eventSubTitle: reduxLanguageTranslations ? reduxLanguageTranslations["freeTimeSlots"] : "Créneau libre",
                    waitingListCount: item.waitingListCount ?? 0,
                    eventDateTime: dateStr,
                    eventDurationTime: timeStr,
                    clientId: item.estate.clientId,
                    officeId: item.estate.officeId,
                    estateId: item.estate.id,
                    internalEventId: f.event?.id,
                };
            });
            result.push({ freeSlotEvents });
        } else {
            result.push({
                freeSlotEvents: [{
                    id: 0,
                    eventCount: item.freeSlotsCount,
                    eventTitle: reduxLanguageTranslations ? reduxLanguageTranslations["freeTimeSlots"] : "Créneaux libres",
                    eventSubTitle: reduxLanguageTranslations ? reduxLanguageTranslations["freeTimeSlots"] : "Créneau libre",
                    waitingListCount: item.waitingListCount ?? 0,
                    eventDateTime: "—",
                    eventDurationTime: "—",
                }]
            });
        }

        // ── To Be Confirmed events ──
        if (item.tbcCount > 0 && item.toBeConfirmed.length > 0) {
            const toBeConfirmedEvents = item.toBeConfirmed.map((t, i) => {
                const { dateStr, timeStr } = formatDateTime(t.event?.startDateTime, t.event?.endDateTime);
                return {
                    id: t.event?.id || i,
                    eventCount: item.tbcCount,
                    eventTitle: reduxLanguageTranslations ? reduxLanguageTranslations["visitToBeConfirmed"] : "Visite à confirmé",
                    eventSubTitle: "", //reduxLanguageTranslations ? reduxLanguageTranslations["toBeConfirmed"] : "À confirmer",
                    agentName: t.agent ? `${t.agent.firstName} ${t.agent.name}` : "—",
                    contactFirstName: t.contact?.firstName || "—",
                    contactName: t.contact?.name || "—",
                    eventDateTime: dateStr,
                    eventDurationTime: timeStr,
                    contactId: t.contact?.id,
                    eventId: t.event?.whiseEventId,
                    clientId: item.estate.clientId,
                    officeId: item.estate.officeId,
                    contactLanguage: t.contact?.languageId || "en-GB",
                    estateId: item.estate.id,
                    agentId: t.agent?.externalId,
                    internalEventId: t.event?.id,
                };
            });
            result.push({ toBeConfirmedEvents });
        } else {
            result.push({
                toBeConfirmedEvents: [{
                    id: 0,
                    eventCount: item.tbcCount,
                    eventTitle: reduxLanguageTranslations ? reduxLanguageTranslations["visitToBeConfirmed"] : "Visite à confirmé",
                    eventSubTitle: "", //reduxLanguageTranslations ? reduxLanguageTranslations["toBeConfirmed"] : "À confirmer",
                    contactFirstName: "—",
                    contactName: "—",
                    eventDateTime: "—",
                    eventDurationTime: "—",
                }]
            });
        }

        return result;
    };

    // Get first confirmed or first TBC event for the "PROCHAINE VISITE" info in collapsed view
    const getNextVisit = (item) => {
        if (item.confirmed.length > 0) {
            const c = item.confirmed[0];
            const { dateStr, timeStr } = formatDateTime(c.event?.startDateTime, c.event?.endDateTime);
            return {
                dateStr,
                timeStr,
                agentName: c.agent ? `${c.agent.firstName} ${c.agent.name}` : "—"
            };
        }
        if (item.toBeConfirmed.length > 0) {
            const t = item.toBeConfirmed[0];
            const { dateStr, timeStr } = formatDateTime(t.event?.startDateTime, t.event?.endDateTime);
            return {
                dateStr,
                timeStr,
                agentName: t.agent ? `${t.agent.firstName} ${t.agent.name}` : "—"
            };
        }
        return null;
    };

    // ── Filter options ───────────────────────────────────────────────────────────
    const smartCalStatusOptions = [
        { value: "active", label: "Active" }, //reduxLanguageTranslations ? reduxLanguageTranslations["createQuestionModalActiveLbl"]  : "Active"  },
        { value: "start", label: "Start" }, //reduxLanguageTranslations ? reduxLanguageTranslations["start"]   : "Start"},
        { value: "pending", label: "Pending" }, //reduxLanguageTranslations ? reduxLanguageTranslations["pending"] : "Pending" },
        { value: "onhold", label: "On Hold" }, //reduxLanguageTranslations ? reduxLanguageTranslations["onHold"]  : "On Hold" },
        { value: "deactivate", label: "Deactivate" }, //reduxLanguageTranslations ? reduxLanguageTranslations["deactivateEstateInDatabase"]   : "Deactivate" },
    ];

    const transactionTypeOptions = [
        { value: "rent", label: reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterStatusRent"]        : "For rent"     },
        { value: "sale", label: reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterStatusSale"]        : "For sale"     },
        { value: "annuity", label: reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterStatusAnnuitySale"] : "Annuity sale" },
    ];

    // ── onChange handlers ─────────────────────────────────────────────────────
    const onChangeSmartCalStatus = (selected) => {
        setSelectedSmartCalStatus(selected);
        setCurrentPage(1);
        setAllEstateWithEvents([]);
    };

    const onChangeAgencies = (selected) => {
        setSelectedAgencies(selected);
        setCurrentPage(1);
        setAllEstateWithEvents([]);
    };

    const onChangeTransactionTypes = (selected) => {
        setSelectedTransactionTypes(selected);
        setCurrentPage(1);
        setAllEstateWithEvents([]);
    };

    const handleClearSearch = () => {
        setSearchInput("");
        setHasMore(false);
        setCurrentPage(1);
        setSelectedSmartCalStatus([]);
        setSelectedAgencies([]);
        setSelectedTransactionTypes([]);
        setExpandedEstates({});
    }

    const handleClearSearchEstateId = () => {
        setSearchEstateId("");
        setHasMore(false);
        setCurrentPage(1);
        setSelectedSmartCalStatus([]);
        setSelectedAgencies([]);
        setSelectedTransactionTypes([]);
        setExpandedEstates({});
    }

    // search query
    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchInput(value);
        setCurrentPage(1);
        setAllEstateWithEvents([]);
    };

    // search query
    const handleSearchEstateIdChange = (e) => {
        const value = e.target.value;
        setSearchEstateId(value);
        setCurrentPage(1);
        setAllEstateWithEvents([]);
    };

    useEffect(() => {
        getAllEstateWithEvents(1, false);
    }, [searchInput, searchEstateId, selectedSmartCalStatus, selectedAgencies, selectedTransactionTypes]);

    // Load more — appends next page
    const handleLoadMore = () => {
        if (!loadingMore && hasMore) {
            getAllEstateWithEvents(currentPage + 1, true);
        }
    };

    useEffect(() => {

        if (confirmationFreeSlotDeletModel && currentEstateId) {

            const handleDelete = async () => {

                // Now await works fine
                const previousEstateStatus = await getEstateStatusFromInDB(currentEstateId, clientId);

                setShowCalendarLoader(true);

                let url = variables.API_URL + `calendar/DeleteEstateFreeSlots?clientId=${clientId}&estateId=${currentEstateId}`;

                const config = {
                    headers: {
                        'Authorization': `Bearer ${user.tokenValue}`,
                        'Content-Type': 'application/json'
                    },
                };

                axios.post(url, {}, config)
                    .then(async response => {
                        if (response.status == 200) {
                            let _delDbFreeSlotResponse;
                            try {
                                _delDbFreeSlotResponse = await deleteEstateFreeSlotEventsFromDB(clientId, currentEstateId);
                                console.log(_delDbFreeSlotResponse);
                            } catch (dbError) {
                                console.error('Error deleting calendar events from DB:');
                                const newEstateStatus = await getEstateStatusFromInDB(currentEstateId, clientId);
                                const actionLogObj = {
                                    estateId: +currentEstateId,
                                    clientId: +clientId,
                                    actionId: 4,
                                    actionStatus: false,
                                    metadata: JSON.stringify({
                                        oldEstateStatus: previousEstateStatus,
                                        newEstateStatus: newEstateStatus,
                                        description: `Free slot DB delete failed`
                                    }),
                                    performedBy: "agent",
                                    parentLogId: null,
                                    syncWithWhise: false,
                                    origin: "EU",
                                    exception: `${JSON.stringify(dbError)}`
                                };
                                addNewActionsLog(actionLogObj);
                                updateParentActionLog({ parentLogId: actionLogObj.parentLogId, metadata: actionLogObj.metadata, exception: actionLogObj.exception });
                                return;
                            }

                            const newEstateStatus = await getEstateStatusFromInDB(currentEstateId, clientId);
                            const freeSlotDeleteCount = getStartingNumber(_delDbFreeSlotResponse);

                            // action log
                            let actionLogObj = {
                                estateId: +currentEstateId,
                                clientId: +clientId,
                                actionId: 4,
                                actionStatus: true,
                                metadata: JSON.stringify({
                                    oldEstateStatus: previousEstateStatus,
                                    newEstateStatus: newEstateStatus,
                                    freeslotDeleteCount: freeSlotDeleteCount,
                                    description: `${freeSlotDeleteCount} free slot is deleted`
                                }),
                                performedBy: "agent",
                                parentLogId: null,
                                syncWithWhise: false,
                                origin: "EU",
                                exception: null
                            };

                            addNewActionsLog(actionLogObj); // action log
                        }
                    })
                    .catch(async (error) => {
                        console.error('Error deleting free slots:', error);
                        setShowCalendarLoader(false);

                        const newEstateStatus = await getEstateStatusFromInDB(currentEstateId, clientId);

                        // action log
                        let actionLogObj = {
                            estateId: +currentEstateId,
                            clientId: +clientId,
                            actionId: 4,
                            actionStatus: false,
                            metaData: JSON.stringify({
                                oldEstateStatus: previousEstateStatus,
                                newEstateStatus: newEstateStatus,
                                description: `Free slot is not deleted`
                            }),
                            performedBy: "agent",
                            parentLogId: null,
                            syncWithWhise: false,
                            origin: "EU",
                            exception: `${JSON.stringify(error)}`
                        };

                        addNewActionsLog(actionLogObj);
                        updateParentActionLog({ parentLogId: actionLogObj.parentLogId, metadata: actionLogObj.metaData, exception: actionLogObj.exception });
                    });
            };

            handleDelete();

        }

    }, [confirmationFreeSlotDeletModel, currentEstateId])

    const handlerClearAllFieldRecords = () => {
        setOpenActionMenu(null);
        handleClearSearch();
        getAllEstateWithEvents(1, false);
    }

    const handlerUpdateEstateDetail = async (estateId) => {
        setOpenActionMenu(null);
        const getSingleEstate = await getSingleEstateDetail(clientId, estateId);
        setAllEstateWithEvents(prev =>
            prev.map(item => item.estate.id === estateId ? getSingleEstate : item)
        );
    }

    const displayEstateStatus = [
        { "id": 1, "name": "Offline" },
        { "id": 2, "name": "Online" },
        { "id": 3, "name": "EstateOfTheMonth" },
        { "id": 4, "name": "Realisations" },
        { "id": 5, "name": "OnlineWebsiteOnly" }
    ]

    useEffect(() => {
        const loadOfficeList = async () => {
            if (reduxClientSetting) {
                const _officesDetail = JSON.parse(reduxClientSetting?.officesDetail);

                if (_officesDetail && _officesDetail.length > 0) {
                    const officeListMap = _officesDetail.map((item) => ({
                        value: item.id,
                        label: item.name,
                    }));
                    setOfficeList(officeListMap);
                } else {
                    const whiseOfficeList = await getWhiseOfficeListService(reduxClientToken, clientId);
                    console.log(whiseOfficeList);

                    if (whiseOfficeList && whiseOfficeList.length > 0) {
                        const officeListMap = whiseOfficeList.map((item) => ({
                            value: item.id,
                            label: item.name,
                        }));
                        setOfficeList(officeListMap);
                    }
                }
            }
        };

        loadOfficeList();
    }, [reduxClientSetting]);

    // filter dropdown show and hide
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (filterRef.current && !filterRef.current.contains(event.target)) {
                setEnableFilterList(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    //useEffect(() => {
    //    const handleClickOutside = (event) => {
    //        if (actionMenuRef.current && !actionMenuRef.current.contains(event.target)) {
    //            setOpenActionMenu(null);
    //        }
    //    };

    //    if (openActionMenu !== null) {
    //        document.addEventListener("mousedown", handleClickOutside);
    //    }

    //    return () => {
    //        document.removeEventListener("mousedown", handleClickOutside);
    //    };
    //}, [openActionMenu]);

    const handlerEstateActionModalOpen = (event) => {
        //if (event != null) {
        //    setTimeout(() => {
        //        setOpenActionMenu(event);
        //    }, 1000);
        //} else {
        //    setOpenActionMenu(event);
        //}
        //if (event != null) {
        //    fetchLatestClientSetting(); 
        //}
        setOpenActionMenu(event);
        setEnableFilterList(false);
    }

    // get History action logs by estate id
    const getHistoryActionLogsByEstateId = async (estateId) => {
        try {
            const url = `${variables.API_URL}LocalEvents/GetActionLog?estateId=${estateId}&pageNumber=1&pageSize=20`;

            const config = {
                headers: {
                    'Content-Type': 'application/json'
                },
            };

            let response = await axios.get(url, config);
            if (response.data) {
                setHistoryActionLogsCount(response.data);
            }
        } catch (error) {
            console.log(error);
        }
    }

    // get purpose status action job buttons
    const getEstatePurposeConfigJobStatusBtn = async (estateId) => {
        try {
            let url = `${variables.API_URL}LocalEvents/GetEstatePurposeConfigIdentification?estateId=${estateId}`;

            const jsonconfig = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            };

            const response = await axios.get(url, jsonconfig);

            if (response.data != undefined) {
                console.log(response.data[0]);
                setEstateJobStatusBtn(response.data[0]);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const getOfficeSettings = () => {
        const jsonconfig = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            }
        };
        const url = variables.API_URL + `Settings/GetSetting?officeId=` + officeId;
        axios.get(url, jsonconfig) // ASP.NET Core API endpoint with headers
            .then(response => {
                let settings = response.data;
                if (response.data != null) {
                    dispatch(setsetting(settings));
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    return (
        <>
            <div className="px-4">

                {/* ── Page header ── */}
                <div className="properties-form-container row align-items-center mb-4">
                    <div className="col-sm-12 col-md-6">
                        <h6 className="page-heading">
                            {reduxLanguageTranslations ? reduxLanguageTranslations["navlinkProperties"] : "Properties"}
                        </h6>
                    </div>
                    <div className="col-sm-12 col-md-6">
                        <div className="d-flex justify-content-end">
                            <button className="property-header-icon me-3"><img src={notification} alt="notifications" /></button>
                            <button className="property-header-icon"><img src={settingsBlack} alt="settings" /></button>
                        </div>
                    </div>
                </div>

                {/* ── Search + Filter ── */}
                <div className="properties-form-container row align-items-center mb-4">
                    <div className="col-sm-12 col-md-3">
                        <h6 className="form-title">
                            {reduxLanguageTranslations ? reduxLanguageTranslations["activePropertiesLbl"] : "Active properties"}
                        </h6>
                    </div>
                    <div className="col-sm-12 col-md-3">
                        <div className="d-flex">
                            <TextField
                                variant="outlined"
                                placeholder={reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListPlaceHolderEstate"] : "Search by estate Id"}
                                size="small"
                                value={searchEstateId}
                                onChange={(e) => {
                                    const numericValue = e.target.value.replace(/[^0-9]/g, "");
                                    handleSearchEstateIdChange({ target: { value: numericValue } });
                                }}
                                onKeyPress={(e) => {
                                    if (!/[0-9]/.test(e.key)) {
                                        e.preventDefault();
                                    }
                                }}
                                onPaste={(e) => {
                                    const pasted = e.clipboardData.getData("text");
                                    if (/[^0-9]/.test(pasted)) {
                                        e.preventDefault();
                                        const numericValue = (searchEstateId + pasted).replace(/[^0-9]/g, "");
                                        handleSearchEstateIdChange({ target: { value: numericValue } });
                                    }
                                }}
                                inputProps={{
                                    inputMode: "numeric",
                                    pattern: "[0-9]*",
                                }}
                                sx={{
                                    width: "100%",
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: 2,
                                        "& fieldset": { borderColor: "#1118270D" },
                                        "&:hover fieldset": { borderColor: "#1118270D" },
                                        "&.Mui-focused fieldset": { borderColor: "#1118270D" },
                                    },
                                }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start" sx={{ mr: 2 }}>
                                            <img src={searchIcon} alt="search" width="15" height="15" />
                                        </InputAdornment>
                                    ),
                                    endAdornment: searchEstateId ? (
                                        <InputAdornment position="end">
                                            <button
                                                onClick={handleClearSearchEstateId}
                                                title="Effacer la recherche"
                                                style={{
                                                    background: "none", border: "none",
                                                    cursor: "pointer", color: "#999",
                                                    fontSize: "14px", padding: "0 4px",
                                                    lineHeight: 1,
                                                }}
                                            >
                                                ✕
                                            </button>
                                        </InputAdornment>
                                    ) : null,
                                }}
                            />
                        </div>
                    </div>

                    <div className="col-sm-12 col-md-6">
                        <div className="d-flex">
                            <TextField
                                variant="outlined"
                                placeholder={reduxLanguageTranslations ? reduxLanguageTranslations["searchByStreetNumberCityZipPrice"] : "Search by estate Id"}
                                size="small"
                                value={searchInput}
                                onChange={handleSearchChange}
                                sx={{
                                    width: "100%",
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: 2,
                                        "& fieldset": { borderColor: "#1118270D" },
                                        "&:hover fieldset": { borderColor: "#1118270D" },
                                        "&.Mui-focused fieldset": { borderColor: "#1118270D" },
                                    },
                                }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start" sx={{ mr: 2 }}>
                                            <img src={searchIcon} alt="search" width="15" height="15" />
                                        </InputAdornment>
                                    ),
                                    // Clear ✕ button on the right — only visible when text is present
                                    endAdornment: searchInput ? (
                                        <InputAdornment position="end">
                                            <button
                                                onClick={handleClearSearch}
                                                title="Effacer la recherche"
                                                style={{
                                                    background: "none", border: "none",
                                                    cursor: "pointer", color: "#999",
                                                    fontSize: "14px", padding: "0 4px",
                                                    lineHeight: 1,
                                                }}
                                            >
                                                ✕
                                            </button>
                                        </InputAdornment>
                                    ) : null,
                                }}
                            />
                            <div style={{ position: "relative" }} ref={filterRef}>
                                <div className="waitinglist-filter-icon d-flex align-items-center ms-2 p-2 border rounded" style={{ cursor: "pointer" }} onClick={() => { setEnableFilterList(!enableFilterList); setOpenActionMenu(null) }}>
                                    <img className="me-2" src={filterIcon} alt="filter" width="15" height="15" />
                                    <span>{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterBtn"] : "Filter"}</span>
                                </div>

                                {/* Filter Dropdown */}
                                <div className={`${enableFilterList ? "" : "d-none"}`}
                                    style={{
                                        position: "absolute",
                                        top: "calc(100% + 6px)",
                                        right: 0,
                                        zIndex: 999,
                                        background: "#fff",
                                        border: "1px solid #e0e0e0",
                                        borderRadius: "10px",
                                        boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
                                        minWidth: "280px",
                                        maxWidth: "280px",
                                        padding: "12px 14px",
                                    }}>

                                    {/* Smart Calendar Status */}
                                    <div className="mb-3">
                                        <label className="mb-1" style={{ fontSize: "12px", fontWeight: 600, color: "#555" }}>
                                            {reduxLanguageTranslations ? reduxLanguageTranslations["smartCalendarStatus"] : "Smart Calendar Status"}
                                        </label>
                                        <MultiSelect
                                            id="smartCalStatus"
                                            value={selectedSmartCalStatus}
                                            options={smartCalStatusOptions}
                                            onChange={onChangeSmartCalStatus}
                                            labelledBy="Select status"
                                            overrideStrings={{
                                                search:    reduxLanguageTranslations ? reduxLanguageTranslations["searchPlaceholderForMultiSelect"] : "Search",
                                                selectAll: reduxLanguageTranslations ? reduxLanguageTranslations["reactMultiSelectSelectAllLabel"]  : "Select All"
                                            }}
                                        />
                                    </div>

                                    {/* Agencies */}
                                    <div className="mb-3">
                                        <label className="mb-1" style={{ fontSize: "12px", fontWeight: 600, color: "#555" }}>
                                            {reduxLanguageTranslations ? reduxLanguageTranslations["settingPageOfficeLbl"] : "Agencies"}
                                        </label>
                                        <MultiSelect
                                            id="agencySelect"
                                            value={selectedAgencies}
                                            options={officeList}
                                            onChange={onChangeAgencies}
                                            labelledBy="Select agency"
                                            overrideStrings={{
                                                search:    reduxLanguageTranslations ? reduxLanguageTranslations["searchPlaceholderForMultiSelect"] : "Search",
                                                selectAll: reduxLanguageTranslations ? reduxLanguageTranslations["reactMultiSelectSelectAllLabel"]  : "Select All"
                                            }}
                                        />
                                    </div>

                                    {/* Transaction Type */}
                                    <div className="mb-3">
                                        <label className="mb-1" style={{ fontSize: "12px", fontWeight: 600, color: "#555" }}>
                                            {reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterStatusLbl"] : "Transaction Type"}
                                        </label>
                                        <MultiSelect
                                            id="transactionType"
                                            value={selectedTransactionTypes}
                                            options={transactionTypeOptions}
                                            onChange={onChangeTransactionTypes}
                                            labelledBy="Select transaction type"
                                            overrideStrings={{
                                                search:    reduxLanguageTranslations ? reduxLanguageTranslations["searchPlaceholderForMultiSelect"] : "Search",
                                                selectAll: reduxLanguageTranslations ? reduxLanguageTranslations["reactMultiSelectSelectAllLabel"]  : "Select All"
                                            }}
                                        />
                                    </div>

                                    {/* Clear all */}
                                    {(selectedSmartCalStatus.length > 0 || selectedAgencies.length > 0 || selectedTransactionTypes.length > 0) && (
                                        <button
                                            onClick={() => { setSelectedSmartCalStatus([]); setSelectedAgencies([]); setSelectedTransactionTypes([]); setCurrentPage(1); setAllEstateWithEvents([]); }}
                                            style={{ fontSize: "12px", color: "#E8303A", background: "none", border: "none", cursor: "pointer", padding: 0, fontWeight: 600 }}
                                        >
                                            {reduxLanguageTranslations ? reduxLanguageTranslations["clearFilters"] : "Clear all filters"}
                                        </button>
                                    )}

                                </div>
                            </div>
                        </div>
                    </div>

                    {
                        showCalendarLoader ?
                            <div className="text-center mt-5">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                            :

                            <div className="col-12">
                                {loading ? (
                                    <div className="text-center mt-5">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                ) : allEstateWithEvents.length > 0 ? (
                                    allEstateWithEvents.map((item, index) => {
                                        const isExpanded = !!expandedEstates[index];
                                        const estate = item.estate;
                                        const statusBadge = getStatusBadge(estate.propertyStatus);
                                        const nextVisit = getNextVisit(item);
                                        const eventsArray = buildEventsArray(item);
                                        const displayStatus = getDisplayStatusBadge(estate.smartCalendarStatus);
                                        //console.log(estate);
                                        // Purpose status
                                        const propertyPurposeStatus = estatePurposeList.filter(item => item.id == estate.purposeStatusId); 
                                        const labelMap = { "fr-BE": "nameFr", "nl-BE": "nameNl" };
                                        const labelKey = labelMap[reduxSelectedLanguage] || "nameEn";

                                        //display status
                                        const propertyDisplayStatus = estateDisplayStatus.filter(item => item.id == estate.categoryId);

                                        // Purpose label
                                        const purposeLabel = estate.purposeId === 1
                                            ? (reduxLanguageTranslations?.["calendarPagePropertyListFilterStatusSale"] || "For sale")
                                            : estate.purposeId === 2
                                                ? (reduxLanguageTranslations?.["calendarPagePropertyListFilterStatusRent"] || "For rent")
                                                : (reduxLanguageTranslations?.["calendarPagePropertyListFilterStatusAnnuitySale"] || "Annuity");

                                        let energyFlagImg = estate.energyClass == "A" ? energyFlagA : estate.energyClass == "B" ? energyFlagB : estate.energyClass == "C" ? energyFlagC : estate.energyClass == "D" ? energyFlagD : estate.energyClass == "E" ? energyFlagE : estate.energyClass == "F" ? energyFlagF : estate.energyClass == "G" ? energyFlagG : estate.energyClass == "Ap" ? energyFlagAp : energyFlagApp;

                                        return (
                                            <div key={estate.id} className="properties-container p-2 rounded mt-2 mb-2">
                                                <div className="p-3 bg-white rounded">

                                                    {/* ══ ESTATE INFO (always visible) ══ */}
                                                    <div className="properties-sub-container d-flex mb-4">
                                                        <div className="properties-details-estate-img me-4"> 
                                                            {
                                                                estate.urlSmall ?
                                                                    <img src={estate.urlSmall} alt="estate" width="100%" />
                                                                    :
                                                                    <img src={placeholderHouse} alt="estate" width="100%" />
                                                            }
                                                            <p className="property-purpose-absolute mb-0">{purposeLabel}</p>
                                                        </div>
                                                        <div className="properites-detail-container">
                                                            {/* Status badges */}
                                                            <div className="d-flex mb-2">
                                                                <button
                                                                    className="property-status-btn rounded me-3 d-flex align-items-center fw-bold duplicate-SpecificDate-addNewSlotBtnText"
                                                                >
                                                                    <img src={loadSmallBlueIcon} className="me-1" alt="" />
                                                                    {capitalizeFirst(propertyPurposeStatus.length > 0 ? propertyPurposeStatus[0][labelKey] : "" || "—")}
                                                                </button>
                                                                <button
                                                                    className="property-status-btn rounded d-flex align-items-center"
                                                                    style={{ backgroundColor: displayStatus.bg, color: "#fff", border: "none" }}
                                                                >
                                                                    <img src={dotWhite} className="property-status-dot-img me-1" alt="" />
                                                                    {/*{estate.smartCalendarStatus ? reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterDisplayStatusOnline"] : "Online" : reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterDisplayStatusOffline"] : "Offline"}*/}
                                                                    { displayEstateStatus.find(s => s.id === estate.estateDisplayStatusId)?.name || 'Online' }
                                                                </button>
                                                            </div>

                                                            {/* Name + category */}
                                                            <div className="d-flex align-items-center mb-2">
                                                                <h2 className="form-title me-2">{estate.name}</h2>
                                                                <img src={houseIdentificationOrangeBatch} className="me-2" alt="" />
                                                                <p className="mb-0 property-category">
                                                                    {/*{estate.subcategoryId === 17 ? "Appartement" : "Maison"}*/}
                                                                    {capitalizeFirst(propertyDisplayStatus.length > 0 ? propertyDisplayStatus[0][labelKey] : "")}
                                                                </p>
                                                            </div>

                                                            {/* Address */}
                                                            <div className="d-flex align-items-center">
                                                                <div className="properties-address-container d-flex me-2">
                                                                    <img src={locationBlue} alt="" />
                                                                    <p className="mb-0 ms-2">{estate.address}, {estate.zip}</p>
                                                                </div>
                                                                <div className="properties-address-container me-2"> 
                                                                    <p className="mb-0">{estate.city}</p>
                                                                </div>
                                                                <p className="mb-0 text-light-gray">#{estate.id}</p>
                                                            </div>

                                                            <hr className="hr-line-properties-page my-2" />

                                                            {/* Features + Price */}
                                                            <div className="d-flex justify-content-between">
                                                                <div className="d-flex align-items-center">
                                                                    <div className="property-detail-icon-container d-flex me-3">
                                                                        <img className="me-1" src={bedBlue} alt="beds" />
                                                                        <p className="mb-0 ms-2">{estate.rooms || "-"}</p>
                                                                    </div>
                                                                    <div className="property-detail-icon-container d-flex me-3">
                                                                        <img className="me-1" src={areaBlue} alt="area" />
                                                                        <p className="mb-0 ms-2">{estate.area ? `${estate.area} m²` : "-"}</p>
                                                                    </div>
                                                                    <div className="property-detail-icon-container d-flex me-3">
                                                                        <img className="me-1" src={showerBlue} alt="rooms" />
                                                                        <p className="mb-0 ms-2">{estate.bathRooms || "-"}</p>
                                                                    </div>
                                                                    <div className="property-detail-icon-container d-flex me-3">
                                                                        <img className="me-1" src={parkingBlue} alt="parking" />
                                                                        <p className="mb-0 ms-2">{estate.parking == null ? "-" : estate.parking ? reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageYesRadioLbl"] : "Yes" : reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageNoRadioLbl"] : "No"}</p>
                                                                    </div>
                                                                    <div className="property-detail-icon-container d-flex me-3">
                                                                        <img className="me-1" src={garageBlue} alt="garage" />
                                                                        <p className="mb-0 ms-2">{estate.garage == null ? "-" : estate.garage ? reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageYesRadioLbl"] : "Yes" : reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageNoRadioLbl"] : "No"}</p>
                                                                    </div>
                                                                    <div className={`${estate.energyClass ? "d-flex position-relative" : "d-none"}`}>
                                                                        <img className="me-1" src={energyFlagImg} height="22px" alt="" />
                                                                    </div>
                                                                </div>
                                                                <div className="properties-price-container d-flex">
                                                                    <h5 className="me-1">
                                                                        {estate.price?.toLocaleString("fr-BE")}
                                                                    </h5>
                                                                    <h5>{estate.currency}</h5>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* ══ COLLAPSED VIEW ══ */}
                                                    {!isExpanded && (
                                                        <div
                                                            className="d-flex align-items-center collapsedEstateEventsbg"
                                                            style={{ gap: "12px", cursor: "pointer", flexWrap: "nowrap" }}
                                                            onClick={() => toggleExpand(index, estate.id)}
                                                        >
                                                            {/* Chevron + title */}
                                                            <div className="d-flex align-items-center" style={{ flexShrink: 0, gap: "6px" }}>
                                                                <img
                                                                    src={arrowUpBlack}
                                                                    alt="expand"
                                                                    style={{ width: "14px", transition: "transform 0.25s ease", transform: "rotate(180deg)" }}
                                                                />
                                                                <h5 className="mb-0" style={{ fontSize: "13px", fontWeight: 600, whiteSpace: "nowrap" }}>
                                                                    {reduxLanguageTranslations ? reduxLanguageTranslations["smartCalendarSection"] : "Volet Smart Calendar"}
                                                                </h5>
                                                            </div>

                                                            {/* Property status badge */}
                                                            <button
                                                                className="property-status-btn rounded d-flex align-items-center"
                                                                style={{ flexShrink: 0, backgroundColor: statusBadge.bg, color: "#fff", border: "none" }}
                                                                onClick={e => e.stopPropagation()}
                                                            >
                                                                <img src={dotWhite} className="property-status-dot-img me-1" alt="" />
                                                                {statusBadge.label}
                                                            </button>

                                                            <div className="small-event-time-card d-flex justify-content-center align-items-center">

                                                                {/* PROCHAINE VISITE pill */}
                                                                <span style={{
                                                                    flexShrink: 0, fontSize: "10px", fontWeight: 700,
                                                                    color: "#27A376",
                                                                    borderRadius: "4px", padding: "3px 7px", whiteSpace: "nowrap"
                                                                }}>
                                                                    {toAllCaps(reduxLanguageTranslations ? reduxLanguageTranslations["nextVisit"] : "PROCHAINE VISITE")}
                                                                </span>

                                                                {/* Date / time / agent — two-line block */}
                                                                {nextVisit ? (
                                                                    <div className="d-flex flex-column" style={{ flexShrink: 0, gap: "1px" }}>
                                                                        <div className="d-flex align-items-center" style={{ gap: "4px" }}>
                                                                            <img src={clockGreen} alt="" style={{ width: "10px", height: "10px" }} />
                                                                            <span style={{ fontSize: "10px", color: "#333", whiteSpace: "nowrap" }}>
                                                                                {nextVisit.dateStr}
                                                                            </span>
                                                                            <span className="fw-bold" style={{ fontSize: "10px", color: "#333", whiteSpace: "nowrap" }}>
                                                                                {nextVisit.timeStr}
                                                                            </span>
                                                                        </div>
                                                                        <div className="d-flex align-items-center" style={{ gap: "4px" }}>
                                                                            <img src={menGreenIcon} alt="" style={{ width: "10px", height: "10px" }} />
                                                                            <span style={{ fontSize: "10px", color: "#555", whiteSpace: "nowrap" }}>
                                                                                {reduxLanguageTranslations ? reduxLanguageTranslations["confirmSlotModalAgentText"] : "Agent"}:
                                                                            </span>
                                                                            <span className="fw-bold" style={{ fontSize: "10px", color: "#555", whiteSpace: "nowrap" }}>
                                                                                {nextVisit.agentName}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <span style={{ fontSize: "10px", color: "#999", flexShrink: 0 }}>{reduxLanguageTranslations ? reduxLanguageTranslations["noVisitScheduled"] : "Aucune visite prévue"}</span>
                                                                )}

                                                            </div>

                                                            {/* 3 mini event count cards */}
                                                            <div className="d-flex" style={{ flex: 1, gap: "8px", minWidth: 0 }}>

                                                                {/* Confirmed */}
                                                                <div className="confirm-events-card rounded d-flex align-items-center justify-content-between"
                                                                    style={{ flex: 1, padding: "6px 10px", minWidth: 0 }}>
                                                                    <div className="d-flex align-items-center" style={{ gap: "6px" }}>
                                                                        <img src={confirmEventsIcon} alt="" style={{ height: "35px", flexShrink: 0 }} />
                                                                        <div>
                                                                            <h5 className="dark-green mb-0 fw-bold" style={{ fontSize: "20px" }}>
                                                                                {item.confirmedCount}
                                                                            </h5>
                                                                            <p className="events-card-title mb-0 fw-bold">{reduxLanguageTranslations ? reduxLanguageTranslations["confirmedVisits"] : "Visites confirmés"}</p>
                                                                        </div>
                                                                    </div>

                                                                    {/*<img src={menuDotsHorizontal} alt="" style={{ width: "14px", flexShrink: 0, opacity: 0.5 }} />*/}
                                                                </div>

                                                                {/* Free slots */}
                                                                <div className="freeSlot-events-card rounded d-flex align-items-center justify-content-between"
                                                                    style={{ flex: 1, padding: "6px 10px", minWidth: 0 }}>
                                                                    <div className="d-flex align-items-center" style={{ gap: "6px" }}>
                                                                        <img src={freeSlotEventsIcon} alt="" style={{ height: "35px", flexShrink: 0 }} />
                                                                        <div>
                                                                            <h5 className="dark-red mb-0 fw-bold" style={{ fontSize: "20px" }}>
                                                                                {item.freeSlotsCount}
                                                                            </h5>
                                                                            <p className="events-card-title mb-0 fw-bold">{reduxLanguageTranslations ? reduxLanguageTranslations["freeTimeSlots"] : "Créneaux libres"}</p>
                                                                        </div>
                                                                    </div>
                                                                    <img className={`${item.freeSlotsCount == 0 ? "dot-icon-estate-card" : "d-none"}`} src={redDotIcon} alt="" />
                                                                </div>

                                                                {/* TBC */}
                                                                <div className="toBeconfirm-events-card rounded d-flex align-items-center justify-content-between"
                                                                    style={{ flex: 1, padding: "6px 10px", minWidth: 0 }}>
                                                                    <div className="d-flex align-items-center" style={{ gap: "6px" }}>
                                                                        <img src={toBeConfirmedEventsIcon} alt="" style={{ height: "35px", flexShrink: 0 }} />
                                                                        <div>
                                                                            <h5 className="dark-orange mb-0 fw-bold" style={{ fontSize: "20px" }}>
                                                                                {item.tbcCount}
                                                                            </h5>
                                                                            <p className="events-card-title mb-0 fw-bold">{reduxLanguageTranslations ? reduxLanguageTranslations["visitToBeConfirmed"] : "Visite à confirmé"}</p>
                                                                        </div>
                                                                    </div>
                                                                    <img className={`${item.tbcCount > 0 ? "dot-icon-estate-card" : "d-none"}`} src={orangeDotIcon} alt="" />
                                                                </div>

                                                            </div>
                                                        </div>
                                                    )}

                                                    {/* ══ EXPANDED VIEW ══ */}
                                                    {isExpanded && (
                                                        <>
                                                            {/* Expanded header row */}
                                                            <div className="d-flex justify-content-between align-items-center mb-4">
                                                                <h5
                                                                    className="mb-0 d-flex align-items-center"
                                                                    style={{ cursor: "pointer", userSelect: "none" }}
                                                                    onClick={() => toggleExpand(index, estate.id)}
                                                                >
                                                                    {reduxLanguageTranslations ? reduxLanguageTranslations["smartCalendarSection"] : "Volet Smart Calendar"}
                                                                    <img
                                                                        src={arrowUpBlack}
                                                                        className="ms-2"
                                                                        style={{ width: "14px", transition: "transform 0.25s ease", transform: "rotate(0deg)" }}
                                                                        alt=""
                                                                    />
                                                                </h5>
                                                                <div className="d-flex align-items-center">
                                                                    <button
                                                                        className="property-status-btn rounded d-flex align-items-center me-2"
                                                                        style={{ backgroundColor: statusBadge.bg, color: "#fff", border: "none", padding: "12px" }}
                                                                    >
                                                                        <img src={dotWhite} className="property-status-dot-img me-1" alt="" />
                                                                        {statusBadge.label}
                                                                    </button>
                                                                    <div style={{ position: "relative" }}>
                                                                        <button
                                                                            className="events-centre-actions-btn rounded d-flex align-items-center"
                                                                            onClick={() => handlerEstateActionModalOpen(openActionMenu === index ? null : index)}
                                                                        >
                                                                            <img src={settingBlue} className="property-status-dot-img me-1" alt="" />
                                                                            {reduxLanguageTranslations ? reduxLanguageTranslations["actionCenter"] : "Centre d'actions"}
                                                                            <img src={arrowDownWhite} className="ms-2" alt="" />
                                                                        </button>

                                                                        {/* Action Dropdown */}
                                                                        {openActionMenu === index && (
                                                                            <div
                                                                                ref={actionMenuRef}
                                                                                className="dropdown-animate"
                                                                                style={{
                                                                                position: "absolute",
                                                                                top: "calc(100% + 6px)",
                                                                                right: 0,
                                                                                zIndex: 999,
                                                                                background: "#fff",
                                                                                border: "1px solid #e0e0e0",
                                                                                borderRadius: "8px",
                                                                                minWidth: "200px",
                                                                                padding: "6px 0",
                                                                            }}>
                                                                                <EstateActionListMenu
                                                                                    estate={estate}
                                                                                    identity={"property"}
                                                                                    showMessage={showMessage}
                                                                                    setShowCalendarLoader={setShowCalendarLoader}
                                                                                    getWhiseCalenderEvents={handlerClearAllFieldRecords}
                                                                                    historyActionLogsCount={historyActionLogsCount}
                                                                                    estateJobActionStatusBtn={estateJobStatusBtn}
                                                                                    setEstateJobStatusBtn={setEstateJobStatusBtn}
                                                                                />
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <ContactWaitingListModel estate={estate} />

                                                            {/* Full events card with real API data */}
                                                            <PropertyEventsCard
                                                                specficEstateEvents={eventsArray}
                                                                estateData={estate}
                                                                handlerClearAllFieldRecords={handlerUpdateEstateDetail}
                                                            />
                                                        </>
                                                    )}

                                                </div>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <div className="text-center mt-5">
                                        <p className="text-muted">{reduxLanguageTranslations?.["noPropertyFound"] || "No property found."}</p>
                                    </div>
                                )}
                            </div>

                    }

                    {/* Load more */}
                    {!loading && (
                        <div className="d-flex justify-content-center align-items-center mt-4 mb-2">
                            {hasMore ? (
                                <button
                                    onClick={handleLoadMore}
                                    disabled={loadingMore}
                                    style={{
                                        padding: "10px 36px",
                                        borderRadius: "8px",
                                        border: "1.5px solid #27A376",
                                        background: "#fff",
                                        color: "#27A376",
                                        fontWeight: 600,
                                        fontSize: "13px",
                                        cursor: loadingMore ? "not-allowed" : "pointer",
                                        opacity: loadingMore ? 0.7 : 1,
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                    }}
                                >
                                    {loadingMore && (
                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            style={{ color: "#27A376" }}
                                        />
                                    )}
                                    {loadingMore
                                        ? "Loading..."
                                        : (reduxLanguageTranslations ? reduxLanguageTranslations["loadMore"] : "Load more")}
                                </button>
                            ) : (
                                allEstateWithEvents.length > 0 && allEstateWithEvents.length >= pageSize && (
                                    <p className="text-muted mb-0" style={{ fontSize: "12px" }}>
                                        {reduxLanguageTranslations
                                            ? reduxLanguageTranslations["allPropertiesLoaded"]
                                            : `All ${allEstateWithEvents.length} properties loaded`}
                                    </p>
                                )
                            )}
                        </div>
                    )}

                </div>
            </div>

            <ConfirmationModal />
        </>
    );
};
